import { confirm } from "./alert.web";

import {
  getUsernameChangeConfirmationCopy,
  type UsernameChange,
} from "./username-change-confirmation-copy";

type Translator = (key: string, options?: Record<string, unknown>) => string;

/**
 * Ask before renaming: the old {handle} link stops working immediately.
 * Resolves true only when the user confirms. A first-time handle (no
 * previous one) needs no confirmation.
 */
export function confirmUsernameChange(
  t: Translator,
  change: UsernameChange,
): Promise<boolean> {
  if (!change.from || change.from === change.to) return Promise.resolve(true);
  const copy = getUsernameChangeConfirmationCopy(t, change);
  return confirm({
    title: copy.title,
    message: copy.message,
    confirmLabel: copy.confirm,
    cancelLabel: copy.cancel,
    destructive: true,
  });
}
